import { InfoIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  InputGroup,
  InputRightElement,
  FormLabel,
  HStack,
  Input,
  Spacer,
  Stack,
  Text,
  Tooltip,
  useToast,
} from '@chakra-ui/react';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import 'react-phone-input-2/lib/style.css';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import { signUpPage } from '../../copy';
import VerifyForm from './verify-form';

const {
  signUp,
  userId,
  firstName,
  middleName,
  lastName,
  passwordDesc,
  confirmPassword,
  phoneNumber,
  emailId,
  next,
} = signUpPage;

const SignUpForm = (props) => {
  const toast = useToast();
  const { switchToSignIn, signup } = props;
  const [passwordSecure, setPasswordSecure] = useState(false);
  const [confirmPasswordSecure, setConfirmPasswordSecure] = useState(false);
  const [signupState, setSignupState] = useState('signup');
  const [signupLoading, setSignupLoading] = useState(false);
  const [phoneNum, setPhoneNum] = useState('');
  const [value, setValue] = useState();

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
      username: '',
      confirmPassword: '',
      country_code: '+1',
      phone_number: '',
      given_name: '',
      middle_name: '',
      family_name: '',
    },
    validationSchema: Yup.object({
      username: Yup.string()
      .required('Please enter user name')
      .matches(/^[a-z0-9]*$/, 'Only lowercase letters and numbers allowed. No special characters or uppercase letters.')
      .test(
        'len',
        'Must be less than 128 characters',
        (val) => val?.length < 128,
      ),
      given_name: Yup.string().required('Please enter name'),
      family_name: Yup.string().required('Please enter family name'),
      email: Yup.string().email('Invalid email').required('Please enter email'),
      phone_number: Yup.string()
        .required('Please enter Mobile Number')
        .test('editPhoneValidation', 'Invalid Mobile Number Format', (val) => {
          if (val) {
            return !(val.replace(/\ /g, '').length < 12);
          }
        }),
      password: Yup.string()
        .required('Please enter password')
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{6,})/,
          'min length 6, One Uppercase, One Lowercase, One Number and One Special Case Character',
        ),
      confirmPassword: Yup.string()
        .required('Please enter confirm password')
        .when('password', {
          is: (val) => (val && val.length > 0 ? true : false),
          then: Yup.string().oneOf(
            [Yup.ref('password')],
            ' Password and Confirm password do not match',
          ),
        }),
    }),
    onSubmit: async (values) => {
      try {
        setSignupLoading(true);
        const res = await signup({
          email: values.email,
          username: values.username,
          password: values.password,
          phone_number: values.phone_number,
          middle_name: values.middle_name,
          given_name: values.given_name,
          family_name: values.family_name,
        });
        setPhoneNum(res?.codeDeliveryDetails?.Destination);
        setSignupState('verification');
        toast({
          title: 'Successfully created account',
          description: 'Verify with code from Mobile Number to move forward',
        });
        setSignupLoading(false);
      } catch (error) {
        setSignupLoading(false);
        if (error.code === 'UserNotFoundException') {
          // setIsSigningIn(false);
        }
        toast({
          title: 'Error',
          description:
            error?.message || 'Something went wrong. Please try again',
        });
      }
    },
  });

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    setFieldTouched,
    setFieldValue,
  } = formik;
  useEffect(() => {
    if (Object.keys(formik.errors).length > 0) {
      const el = document.getElementsByName(Object.keys(formik.errors)[0])[0];
      if (el) {
        el.focus();
      }
    }
  }, [formik.isSubmitting]);
  return (
    <Stack px={12}>
      {signupState === 'signup' ? (
        <form onSubmit={handleSubmit}>
          <Stack>
            <h1>{signUp}</h1>
          </Stack>
          <Stack spacing={4} mt="3">
            <FormControl
              id="username"
              isInvalid={!!errors.username && !!touched.username}
            >
              <FormLabel display="inline">
                {userId}{' '}
                <Text as="span" color="brand.red">
                  *
                </Text>
              </FormLabel>
              <Tooltip
                hasArrow
                label="(Ex:-sakula,sridhar420) -  Should be unique &amp; no special charecter allowed."
                bg="brand.red"
              >
                <InfoIcon fontSize="10px" color="brand.red" />
              </Tooltip>
              <Input
                type="text"
                name="username"
                // {...inputTextStyleProps}
                onBlur={handleBlur}
                value={values.username}
                onChange={(e) => {
                  setFieldValue('username', e.target.value);
                }}
                placeholder="e.g. Michel88"
              />
              <FormErrorMessage>{errors.username}</FormErrorMessage>
            </FormControl>
            <Flex alignItems="top">
              <FormControl
                id="given_name"
                isInvalid={!!errors.given_name && !!touched.given_name}
              >
                <FormLabel>
                  {firstName}{' '}
                  <Text as="span" color="brand.red">
                    *
                  </Text>
                </FormLabel>
                <Input
                  type="text"
                  name="given_name"
                  // {...inputTextStyleProps}
                  onBlur={handleBlur}
                  value={values.given_name}
                  onChange={(e) => {
                    setFieldValue('given_name', e.target.value);
                  }}
                  placeholder="e.g. Michel"
                />

                <FormErrorMessage>{errors.given_name}</FormErrorMessage>
              </FormControl>
              <FormControl id="middle_name" ml="4">
                <FormLabel>{middleName}</FormLabel>
                <Input
                  type="text"
                  name="middle_name"
                  // {...inputTextStyleProps}
                  onBlur={handleBlur}
                  value={values.middle_name}
                  onChange={(e) => {
                    setFieldValue('middle_name', e.target.value);
                  }}
                />
                <Box> </Box>
              </FormControl>
              <FormControl
                ml="4"
                id="family_name"
                isInvalid={!!errors.family_name && !!touched.family_name}
              >
                <FormLabel>
                  {lastName}{' '}
                  <Text as="span" color="brand.red">
                    *
                  </Text>
                </FormLabel>
                <Input
                  type="text"
                  name="family_name"
                  // {...inputTextStyleProps}
                  onBlur={handleBlur}
                  value={values.family_name}
                  onChange={(e) => {
                    setFieldValue('family_name', e.target.value);
                  }}
                  placeholder="e.g. Bryn"
                />

                <FormErrorMessage>{errors.family_name}</FormErrorMessage>
              </FormControl>
            </Flex>
            <FormControl
              id="email"
              isInvalid={!!errors.email && !!touched.email}
            >
              <FormLabel>
                {emailId}{' '}
                <Text as="span" color="brand.red">
                  *
                </Text>
              </FormLabel>
              <Input
                name="email"
                // {...inputTextStyleProps}
                type="email"
                onBlur={handleBlur}
                value={values.email}
                onChange={(e) => {
                  setFieldValue('email', e.target.value);
                }}
                placeholder="e.g. example@1800spirits.com"
              />{' '}
              <FormErrorMessage>{errors.email}</FormErrorMessage>
            </FormControl>
            <HStack color="#7e7c7c">
              <FormControl
                isInvalid={!!errors.phone_number && !!touched.phone_number}
              >
                <FormLabel>
                  {phoneNumber}{' '}
                  <Text as="span" color="brand.red">
                    *
                  </Text>
                </FormLabel>
                {/* <HStack>
                  <Input
                    name="country_code"
                    id="country_code"
                    // {...inputTextStyleProps}
                    type="text"
                    width="70px"
                    onBlur={handleBlur}
                    value={values.country_code || '+1'}
                    onChange={(e) => {
                      setFieldValue('country_code', e.target.value);
                    }}
                    placeholder="+1"
                  />
                  <Input
                    name="phone_number"
                    id="phone_number"
                    // {...inputTextStyleProps}
                    type="text"
                    onBlur={handleBlur}
                    value={values.phone_number}
                    onChange={(e) => {
                      setFieldValue('phone_number', e.target.value);
                    }}
                    placeholder="e.g. 1234567891"
                  />
                </HStack>{' '} */}
                <PhoneInput
                  specialLabel={''}
                  countryCodeEditable={false}
                  country="us"
                  value={values.phone_number}
                  name="phone_number"
                  inputStyle={{ width: '100%' }}
                  onBlur={() => {
                    setFieldTouched('phone_number', true);
                  }}
                  onChange={(value, country, e, formattedValue) => {
                    const tempValue = `+${value}`;
                    setFieldValue('phone_number', tempValue);
                  }}
                />
                {/* National: {value && formatPhoneNumber(value)} */}
                <FormErrorMessage>{errors.phone_number}</FormErrorMessage>
              </FormControl>
            </HStack>

            <FormControl isInvalid={!!errors.password && !!touched.password}>
              <FormLabel display="inline">
                {passwordDesc}{' '}
                <Text as="span" color="brand.red">
                  *
                </Text>
              </FormLabel>
              <Tooltip
                hasArrow
                label="Min Length 6, One Numerical, One Caps, One Special Chatacter."
                bg="brand.red"
              >
                <InfoIcon fontSize="10px" color="brand.red" />
              </Tooltip>
              <InputGroup>
                <Input
                  id="password"
                  // {...inputTextStyleProps}
                  autoComplete="new-password"
                  type={!passwordSecure ? 'password' : 'text'}
                  onBlur={handleBlur}
                  name="password"
                  value={values.password}
                  onChange={handleChange}
                  placeholder="Please enter password"
                />{' '}
                <InputRightElement>
                  <Button
                    tabIndex="-1"
                    color="brand.black"
                    variant="link"
                    onClick={() => {
                      setPasswordSecure(!passwordSecure);
                    }}
                  >
                    {passwordSecure ? <FaEye /> : <FaEyeSlash />}
                  </Button>
                </InputRightElement>
              </InputGroup>
              <FormErrorMessage>{errors.password}</FormErrorMessage>
            </FormControl>
            <FormControl
              id="password"
              isInvalid={!!errors.confirmPassword && touched.confirmPassword}
            >
              <FormLabel display="inline">
                {confirmPassword}{' '}
                <Text as="span" color="brand.red">
                  *
                </Text>
              </FormLabel>
              <InputGroup>
                <Input
                  id="confirmPassword"
                  // {...inputTextStyleProps}
                  type={!confirmPasswordSecure ? 'password' : 'text'}
                  onBlur={handleBlur}
                  value={values.confirmPassword}
                  name="confirmPassword"
                  onChange={handleChange}
                  placeholder="Please Re-enter password"
                />
                <InputRightElement>
                  <Button
                    tabIndex="-1"
                    color="brand.black"
                    variant="link"
                    onClick={() => {
                      setConfirmPasswordSecure(!confirmPasswordSecure);
                    }}
                  >
                    {confirmPasswordSecure ? <FaEye /> : <FaEyeSlash />}
                  </Button>
                </InputRightElement>
              </InputGroup>
              <FormErrorMessage>{errors.confirmPassword}</FormErrorMessage>
            </FormControl>

            <Stack spacing={10}>
              <Flex pb="8">
                <Box>
                  <Button
                    variant="cancel-button"
                    onClick={() => switchToSignIn()}
                    borderColor="brand.red"
                    color="brand.red"
                  >
                    Login
                  </Button>
                </Box>
                <Spacer />
                <Box>
                  <Button isLoading={signupLoading} type="submit">
                    {next}
                  </Button>
                </Box>
              </Flex>
            </Stack>
          </Stack>
        </form>
      ) : signupState === 'verification' ? (
        <VerifyForm
          username={values.username}
          phoneNumberValue={phoneNum}
          switchToSignIn={switchToSignIn}
        />
      ) : null}
    </Stack>
  );
};

const stateMapper = () => ({});

const dispatchMapper = (dispatch) => ({
  signup: dispatch.auth.signup,
});

export default connect(stateMapper, dispatchMapper)(SignUpForm);
